export default __webpack_public_path__ + "static/media/element_spec_9.2205b8a9.webp";